







import Vue from "vue";
import { ImportMetadataApi } from "../api/ImportMetadataApi";
import { ImportMetadata } from "../models/ImportMetadata";
import { DocumentNonReconnuApi } from "../api/DocumentNonReconnuApi";

const REFRESH_INTERVAL = 60 * 1000;

const PROCESSING_SREFS = [
    "app.document_processing",
    "app.bulletin_de_salaire_list",
    "app.facture_fournisseur_list",
];
const NON_RECONNU_SREF = "app.document_non_reconnu_list";

// État partagé par toutes les instances (un badge par entrée de menu) : un
// seul timer, une requête pour les analyses en cours et une pour le stock de
// documents non reconnus, avec limit=1 (seul paginator.total_count est lu).
const shared = {
    state: Vue.observable({
        processing: 0,
        nonReconnus: 0,
    }),
    registrations: {} as Record<string, number>,
    timer: null as any,
    importMetadataApi: new ImportMetadataApi(),
    documentNonReconnuApi: new DocumentNonReconnuApi(),
};

function isRegistered(sref: string): boolean {
    return (shared.registrations[sref] || 0) > 0;
}

function refreshCounts() {
    if (isRegistered(NON_RECONNU_SREF)) {
        shared.documentNonReconnuApi.getAll({ limit: 1 }).then(function (res) {
            shared.state.nonReconnus = res.paginator.total_count;
        });
    }
    if (PROCESSING_SREFS.some(isRegistered)) {
        shared.importMetadataApi
            .getAll({
                status: _.join(
                    [
                        ImportMetadata.STATUS["PENDING"],
                        ImportMetadata.STATUS["PROCESSING"],
                    ],
                    ","
                ),
                limit: 1,
            })
            .then(function (res) {
                shared.state.processing = res.paginator.total_count;
            });
    }
}

// Les instances du menu s'enregistrent toutes au même tick : un seul
// rafraîchissement coalescé, pas un par entrée de menu.
let refreshScheduled = false;
function scheduleRefresh() {
    if (refreshScheduled) {
        return;
    }
    refreshScheduled = true;
    setTimeout(function () {
        refreshScheduled = false;
        refreshCounts();
    }, 50);
}

function register(sref: string) {
    shared.registrations[sref] = (shared.registrations[sref] || 0) + 1;
    if (!shared.timer) {
        shared.timer = setInterval(refreshCounts, REFRESH_INTERVAL);
    }
    const relevant =
        sref == NON_RECONNU_SREF || PROCESSING_SREFS.indexOf(sref) !== -1;
    if (relevant && shared.registrations[sref] === 1) {
        scheduleRefresh();
    }
}

function unregister(sref: string) {
    shared.registrations[sref] = Math.max(
        0,
        (shared.registrations[sref] || 0) - 1
    );
    const active = Object.keys(shared.registrations).some(isRegistered);
    if (!active && shared.timer) {
        clearInterval(shared.timer);
        shared.timer = null;
    }
}

export default {
    name: "DocumentProcessingCount",
    props: {
        sref: String,
    },
    data() {
        return {
            shared: shared.state,
        };
    },
    computed: {
        count(): number {
            if (this.sref == NON_RECONNU_SREF) {
                return this.shared.nonReconnus;
            }
            if (PROCESSING_SREFS.indexOf(this.sref) !== -1) {
                return this.shared.processing;
            }
            return 0;
        },
    },
    created() {
        if (this.sref) {
            register(this.sref);
        }
    },
    destroyed() {
        if (this.sref) {
            unregister(this.sref);
        }
    },
};
